import { render, staticRenderFns } from "./TrainingItemPage.vue?vue&type=template&id=80addbdc&"
import script from "./TrainingItemPage.vue?vue&type=script&lang=js&"
export * from "./TrainingItemPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItemPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports